/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../../common";
import type {
  MorphoBundler3Unwrapper,
  MorphoBundler3UnwrapperInterface,
} from "../../../../contracts/periphery/MorphoBundler3Unwrapper.sol/MorphoBundler3Unwrapper";

const _abi = [
  {
    inputs: [],
    name: "MalformedBody",
    type: "error",
  },
  {
    inputs: [],
    name: "MalformedHeader",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedMode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "unwrap",
    outputs: [
      {
        components: [
          {
            internalType: "enum Operation",
            name: "operation",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "dataLocation",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "dataSize",
            type: "uint256",
          },
        ],
        internalType: "struct UnwrappedTransaction[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MorphoBundler3UnwrapperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MorphoBundler3UnwrapperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MorphoBundler3Unwrapper__factory extends ContractFactory {
  constructor(...args: MorphoBundler3UnwrapperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      MorphoBundler3Unwrapper & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): MorphoBundler3Unwrapper__factory {
    return super.connect(runner) as MorphoBundler3Unwrapper__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MorphoBundler3UnwrapperInterface {
    return new Interface(_abi) as MorphoBundler3UnwrapperInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): MorphoBundler3Unwrapper {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as MorphoBundler3Unwrapper;
  }
}
